enum Privilege {
    AS_SHOW_SHIPIT_TILE = 'AS_show_ShipIT_tile',
    AS_SHOW_GPP_TILE = 'AS_show_GPP_tile',
    AS_SHOW_TRACKING_TILE = 'AS_show_Tracking_tile',
    AS_SHOW_ACTION_LOG_TILE = 'AS_show_ActionLog_tile',
    AS_UM_CREATE_USER = 'AS_UM_create_user',
    AS_UM_CHANGE_USER = 'AS_UM_change_user',
    AS_UM_DELETE_USER = 'AS_UM_delete_user',
    AS_UM_CHANGE_USER_DISABLE = 'AS_UM_change_user_disable',
    AS_UM_CHANGE_USER_ROLE = 'AS_UM_change_user_role',
    AS_UM_CHANGE_USER_AUTH_TYPE = 'AS_UM_change_user_auth_type',
    AS_UM_CHANGE_ASSIGN_SHIPPER = 'AS_UM_change_assign_shipper',
    AS_UM_CHANGE_REMOVE_SHIPPER = 'AS_UM_change_remove_shipper',
    AS_UM_CHANGE_ASSIGN_SHIPPER_WILDCARD = 'AS_UM_change_assign_shipper_wildcard',
    AS_UM_CHANGE_ASSIGN_LOCATION_WILDCARD = 'AS_UM_change_assign_location_wildcard',
    SEE_CORE_REGION_USERS = 'AS_UM_see_core_region',
    AS_UM_MANAGE_REQUEST_LIST = 'AS_UM_manage_request_list',
    AS_SM_VIEW_SHIPPER = 'AS_SM_view_shipper', //TODO screen for this permission does not exist yet, no task
    AS_SM_CHANGE_SHIPPER = 'AS_SM_change_shipper',
    AS_SM_TIMEOUTS_LVR = 'AS_SM_timeouts_LVR',
    AS_SM_TIMEOUTS_CBR = 'AS_SM_timeouts_CBR',
    AS_SM_TIMEOUTS_SSR = 'AS_SM_timeouts_SSR',
    AS_SM_TIMEOUTS_CCO = 'AS_SM_timeouts_CCO',
    AS_SM_TIMEOUTS_ISRS = 'AS_SM_timeouts_ISRS',
    AS_SM_TIMEOUTS_IT = 'AS_SM_timeouts_IT',
    AS_SM_TIMEOUTS_ROUTING_API = 'AS_SM_timeouts_ROUTING_API',
    AS_SM_ROUTING_STRATEGY = 'AS_SM_routing_strategy',
    AS_SM_REAL_SHIPPER_ALLOWED = 'AS_SM_real_shipper_allowed',
    AS_SM_TRACK_ID_INJECTION = 'AS_SM_trackID_injection',
    S2S_CRUD_STORE = 'S2S_CRUD_store',
    S2S_SHIPMENT_CREATION = 'S2S_Shipment_Creation',
    PU_CREATE = 'PU_create'
}

export { Privilege };
